import { CareTeamPage } from "./careTeam";

export const CareTeam = CareTeamPage;
